module.exports = function() {
  return new Worker(__webpack_public_path__ + "8efa02297cb97aceb444.worker.js");
};